import { NavMarker } from 'react-rhumb';
import ProductInfoContainer from '../../common/ProductInfoContainer';
import MobileDropdownNav from '../MobileDropdownNav';
import SegmentedTabs from '../../layout/tabs/SegmentedTabs';
import MobileCurrencyPicker from '../MobileCurrencyPicker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileWrapperWithTabs = ({
  navMarkerName,
  navItem,
  tab,
  setTab,
  children
}) => {
  return /*#__PURE__*/_jsxs("div", {
    "data-selenium-id": "page-success",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: navMarkerName
    }), /*#__PURE__*/_jsx(SegmentedTabs, {
      selectedTab: tab,
      bordered: true,
      use: "enclosed",
      path: `/${navItem}`,
      setTab: setTab
    }), /*#__PURE__*/_jsx(MobileCurrencyPicker, {}), /*#__PURE__*/_jsx(MobileDropdownNav, {
      selectedNavItem: navItem
    }), /*#__PURE__*/_jsx(ProductInfoContainer, {
      children: children
    })]
  });
};
export default MobileWrapperWithTabs;